import { createVinByRegExpRemover } from '.';
import { ConsumerTrackingServiceV2 } from './tfs-v2/consumer';
import { SharedTrackingServiceV2 } from './tfs-v2/shared';
import { createDefaultLogger } from './logging';
import { DataLayerAdapter } from './datalayer/data-layer-adapter';
/**
 * Default client-side tracking service for oneAudiOS.
 * Uses the same tracking concepts as https://github.com/volkswagen-onehub/audi-tracking-service
 */
export class OneSightTrackingService {
    delegate;
    name;
    logger;
    featureAppId;
    constructor(appId, datalayer, urlSanitizer, logger) {
        this.featureAppId = appId;
        this.logger = logger ?? createDefaultLogger();
        const sharedService = new SharedTrackingServiceV2(datalayer ?? DataLayerAdapter.getInstance().getDataLayer(), urlSanitizer ?? createVinByRegExpRemover(), this.logger);
        this.delegate = new ConsumerTrackingServiceV2(sharedService, this.featureAppId);
        this.logger.debug(`${this.logPrefix()} Initialised`);
    }
    get featureAppName() {
        this.logger.debug(`${this.logPrefix()} Getting feature app name`);
        return this.name;
    }
    set featureAppName(featureAppName) {
        const oldName = this.name;
        this.delegate.featureAppName = featureAppName;
        this.name = featureAppName;
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        this.logger.debug(`${this.logPrefix()} Updating feature app name from '${oldName}' to '${featureAppName}'`);
    }
    track(event) {
        this.logger.info(`${this.logPrefix()} Tracking event`, event);
        this.delegate.track(event);
    }
    trackInternalNavigation(event, href) {
        this.logger.info(`${this.logPrefix()} Tracking internal navigation event to '${href}'`, event);
        this.delegate.trackInternalNavigation(event, href);
    }
    updateComponent(componentUpdate) {
        this.logger.info(`${this.logPrefix()} Updating component`, componentUpdate);
        this.delegate.updateComponent(componentUpdate);
    }
    updateUser(userUpdate) {
        this.logger.info(`${this.logPrefix()} Updating user`, userUpdate);
        this.delegate.updateUser(userUpdate);
    }
    registerImpressionTracking(element, createDefaultImpressionEvent, furtherImpressions) {
        this.logger.info(`${this.logPrefix()} Registering impression tracking on element '${element?.tagName}'`);
        return this.delegate.registerImpressionTracking(element, createDefaultImpressionEvent, furtherImpressions);
    }
    evaluateLinkType(targetUrl) {
        this.logger.debug(`${this.logPrefix()} Evaluating link type of '${targetUrl}'`);
        return this.delegate.evaluateLinkType(targetUrl);
    }
    sanitizeUrl(url) {
        this.logger.debug(`${this.logPrefix()} Sanitizing url '${url}'`);
        return this.delegate.sanitizeUrl(url);
    }
    getDatalayer() {
        this.logger.debug(`${this.logPrefix()} Getting data layer. Please don't use the datalayer directly!`);
        return this.delegate.getDatalayer();
    }
    unbind() {
        this.logger.debug(`${this.logPrefix()} Unbinding`);
        this.delegate.unbind();
    }
    logPrefix() {
        return `[OneSightTracking(id='${this.featureAppId}' / name='${this.name}')]`;
    }
}
